import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Badge,
  Label,
} from "reactstrap";

const PaymentTypeDetail = ({ isOpen, toggle, data }) => {
  if (!data) return null;

  const DetailItem = ({ label, value, icon }) => (
    <div className="mb-4">
      <Label className="text-muted text-uppercase fw-bold mb-1" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
        {label}
      </Label>
      <div className="d-flex align-items-center">
        {icon && <span className="text-primary me-2">{icon}</span>}
        <div className="fs-15 fw-medium text-dark">
          {value || <span className="text-muted fw-normal italic">Not Provided</span>}
        </div>
      </div>
    </div>
  );

  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      centered 
      size="md" 
      contentClassName="border-0 shadow-lg"
      style={{ borderRadius: '15px', overflow: 'hidden' }}
    >
      {/* Clean & Simple Header */}
      <ModalHeader 
        toggle={toggle} 
        className="border-bottom p-3"
      >
        <div className="d-flex align-items-center py-1">
  {/* Icon/Image Avatar */}
  <div 
    className="d-flex align-items-center justify-content-center rounded-circle border shadow-sm bg-white me-3" 
    style={{ width: '50px', height: '50px', flexShrink: 0 }}
  >
    {(data.displayImage || data.imagePath) ? (
      <img
        src={data.displayImage || data.imagePath}
        alt={data.name}
        className="img-fluid p-2"
        style={{ maxHeight: '100%', objectFit: 'contain' }}
      />
    ) : (
      <i className="ri-bank-card-2-line fs-20 text-primary"></i>
    )}
  </div>

  {/* Title & Badge Group */}
  <div className="flex-grow-1">
    <h5 className="mb-1 fw-bold text-dark lh-1">{data.name}</h5>
    <div className="d-flex align-items-center">
      <Badge 
        color="light" 
        className="text-muted border fw-normal py-1 px-2"
        style={{ fontSize: '10px' }}
      >
        <span className="opacity-75 me-1">CODE:</span>
        <span className="text-dark fw-semibold">{data.code || 'N/A'}</span>
      </Badge>
    </div>
  </div>
</div>
      </ModalHeader>

      <ModalBody className="p-4 bg-light-subtle">
        {/* Status & Type Bar */}
        <div className="d-flex justify-content-between align-items-center mb-4 p-3 bg-white rounded-3 shadow-sm">
          <div>
            <span className="text-muted small d-block mb-1">Current Status</span>
            <Badge color={data.isActive ? "success" : "danger"} pill className="px-3">
              {data.isActive ? "● Active" : "○ Inactive"}
            </Badge>
          </div>
          <div className="text-end">
            <span className="text-muted small d-block mb-1">Source</span>
            <Badge color="secondary" className="bg-opacity-10 text-secondary border px-3">
              {data.isSystemGenerated ? "System Core" : "User Defined"}
            </Badge>
          </div>
        </div>

        {/* Info Grid */}
        <div className="bg-white p-4 rounded-4 shadow-sm border border-light">
          <h6 className="text-primary fw-bold mb-4 border-bottom pb-2">
            Details & Accounting
          </h6>
          
          <Row>
            <Col md={12}>
              <DetailItem 
                label="Description" 
                value={data.description} 
              />
            </Col>
            
            <Col md={6}>
              <DetailItem 
                label="Ledger Link" 
                value={data.ledgerName ? `${data.ledgerName}` : null} 
              />
            </Col>
            <Col md={6}>
              <DetailItem 
                label="Ledger Code" 
                value={data.ledgerCode} 
              />
            </Col>

            <Col md={12}>
              <div className="mt-2 p-3 bg-light rounded-3 d-flex justify-content-between align-items-center">
                <span className="text-muted small fw-bold text-uppercase">Account Number</span>
                <span className="font-monospace fw-bold text-primary fs-16">
                   {data.accountNumber || "---- ---- ----"}
                </span>
              </div>
            </Col>
          </Row>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PaymentTypeDetail;